import userLocationMarkerTpl from './user-location-marker-info-window.tpl.html!text';
import shopMarkerTpl from './shop-marker-info-window.tpl.html!text';

class InfoWindowCtrl {

    constructor($scope, $sce, $compile, $timeout, $state, storeServ) {
        this.$scope = $scope;
        this.$sce = $sce;
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.$state = $state;
        this.storeServ = storeServ;

        this.ngOnInit();

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    /**
     *  ngOnInit.
     */

    ngOnInit() {

        this.infoWindow = new google.maps.InfoWindow({
            maxWidth: 220
        });

        this.infoWindowProperties = this.storeServ.getState().toggleInfoWindow;

        this.launch();

        this.infoWindowCloseListener = this.infoWindow.addListener('closeclick', this.onInfoWindowClose.bind(this));
    }

    /**
     *  Listeners.
     */

    onInfoWindowClose() {
        
        this.cancelTheCompileTimeout();

        this.destroyTheExistingInfoWindowScope();

        this.storeServ.dispatch({
            type: 'SET_CLICKED_SHOP_MARKER_COORDINATES',
            coordinates: null
        });

        this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: null
        });
    }

    /**
     *  Workers.
     */

    launch() {
        this.createNewInfoWindowScope();

        this.addInfoWindowPropsToInfoWindowScope();

        this.timeoutDuration = 100;

        if (this.infoWindowProperties.template === 'userLocationMarker') {

            this.templateToCompile = userLocationMarkerTpl;

            this.compileTheTemplateWithTheInfoWindowScope();

        } else {

            this.templateToCompile = shopMarkerTpl;

            this.sanitizePropertiesInsideTheInfoWindowScope();

            this.bindGoToShopDetailsPageToInfoWindowScope();
        }

        this.compileTheTemplateWithTheInfoWindowScope();

        this.compileTimeout = this.$timeout(() => {

            this.infoWindow.setContent(this.generatedTemplate);

            this.infoWindow.setPosition({
                lat: this.infoWindowScope.markerProperties.lat,
                lng: this.infoWindowScope.markerProperties.lng,
            });

            this.infoWindow.setOptions({
                pixelOffset: new google.maps.Size(0, this.infoWindowScope.markerProperties.pixelOffset)
            });

            this.infoWindow.open(this.map);

        }, this.timeoutDuration);
    }

    createNewInfoWindowScope() {
        this.infoWindowScope = this.$scope.$new();
    }

    addInfoWindowPropsToInfoWindowScope() {
        this.infoWindowScope.markerProperties = angular.copy(this.infoWindowProperties.markerProperties);
    }

    sanitizePropertiesInsideTheInfoWindowScope() {
        angular.forEach(this.infoWindowScope.markerProperties, (value, key) => {
            if (typeof this.infoWindowScope.markerProperties[key] === 'string') {
                this.infoWindowScope.markerProperties[key] = this.$sce.trustAsHtml(this.infoWindowScope.markerProperties[key]);
            }
        });
    }

    bindGoToShopDetailsPageToInfoWindowScope() {
        this.infoWindowScope.$state = this.$state;
        this.infoWindowScope.goToShopDetailsPage = function(district, city, shopUrl, code) {
            district = district.$$unwrapTrustedValue();
            city = city.$$unwrapTrustedValue();
            name = shopUrl.$$unwrapTrustedValue().match("nume\/(.*)\/cod")[1];
            code = code.$$unwrapTrustedValue();
            this.$state.go('shop-details', {
                district,
                city,
                name,
                code
            });
        };
    }

    compileTheTemplateWithTheInfoWindowScope() {
        this.generatedTemplate = this.$compile(this.templateToCompile)(this.infoWindowScope)[0];
    }

    destroyTheExistingInfoWindowScope() {
        this.infoWindowScope && this.infoWindowScope.$destroy();
    }

    cancelTheCompileTimeout() {
        this.compileTimeout && this.$timeout.cancel(this.compileTimeout);
    }

    /**
     *  Destroy.
     */

    ngOnDestroy() {
        this.cancelTheCompileTimeout();
        
        this.infoWindowCloseListener.remove();

        this.infoWindow.close();
    }
}

InfoWindowCtrl.$inject = ['$scope', '$sce', '$compile', '$timeout', '$state', 'storeServ'];

var infoWindowComponent = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: InfoWindowCtrl,
        bindToController: {
            map: '='
        }
    };
};

export default infoWindowComponent;
